import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [demoFormData, setDemoFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleDemoChange = (e) => {
    setDemoFormData({ ...demoFormData, [e.target.name]: e.target.value });
  };

  const handleDemoSubmit = (e) => {
    e.preventDefault();
    emailjs.send('your_service_id', 'your_demo_template_id', {
      from_name: demoFormData.name,
      from_email: demoFormData.email,
      phone: demoFormData.phone,
      message: demoFormData.message,
      subject: 'Agendamento de Demonstração - Olimars'
    }, 'your_user_id')
    .then((result) => {
      alert('Pedido de demonstração enviado com sucesso! Entraremos em contato em breve.');
      setDemoFormData({ name: '', email: '', phone: '', message: '' });
      setIsModalOpen(false);
    }, (error) => {
      alert('Erro ao enviar pedido. Tente novamente.');
      console.log(error.text);
    });
  };

  return (
    <>
      <section id="home" className="relative bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 text-white py-32 overflow-hidden">
        {/* Futuristic Background */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-pink-500/20"></div>
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
                             radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
                             radial-gradient(circle at 40% 40%, rgba(120, 219, 226, 0.3) 0%, transparent 50%)`
          }}></div>
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-7xl md:text-8xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-pink-400 drop-shadow-lg">
              Olimars
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-cyan-100 drop-shadow-md">
              A Revolução Digital ao Alcance do Seu Negócio
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-gradient-to-r from-cyan-500 to-pink-500 text-white px-8 py-3 rounded-lg font-semibold hover:from-cyan-600 hover:to-pink-600 transition duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Agendar Demonstração
            </button>
          </div>
        </div>
        {/* Animated Futuristic Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 left-10 animate-spin" style={{ animationDelay: '0s', animationDuration: '8s' }}>
            <div className="w-16 h-16 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-full flex items-center justify-center shadow-lg animate-pulse">
              <span className="text-2xl">👤</span>
            </div>
          </div>
          <div className="absolute top-20 right-20 animate-bounce" style={{ animationDelay: '1s', animationDuration: '3s' }}>
            <div className="w-16 h-16 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-full flex items-center justify-center shadow-lg animate-pulse">
              <span className="text-2xl">📅</span>
            </div>
          </div>
          <div className="absolute bottom-20 left-20 animate-spin" style={{ animationDelay: '2s', animationDuration: '10s' }}>
            <div className="w-16 h-16 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-full flex items-center justify-center shadow-lg animate-pulse">
              <span className="text-2xl">🏢</span>
            </div>
          </div>
          <div className="absolute bottom-10 right-10 animate-bounce" style={{ animationDelay: '0.5s', animationDuration: '4s' }}>
            <div className="w-16 h-16 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-full flex items-center justify-center shadow-lg animate-pulse">
              <span className="text-2xl">🤖</span>
            </div>
          </div>
          {/* Floating Particles */}
          <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-cyan-400 rounded-full animate-ping opacity-80" style={{ animationDelay: '0s' }}></div>
          <div className="absolute top-3/4 right-1/4 w-4 h-4 bg-pink-400 rounded-full animate-ping opacity-80" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-1/4 left-3/4 w-4 h-4 bg-purple-400 rounded-full animate-ping opacity-80" style={{ animationDelay: '2s' }}></div>
          <div className="absolute top-1/2 left-1/2 w-3 h-3 bg-yellow-400 rounded-full animate-ping opacity-60" style={{ animationDelay: '0.5s' }}></div>
          <div className="absolute top-1/3 right-1/3 w-2 h-2 bg-green-400 rounded-full animate-ping opacity-50" style={{ animationDelay: '1.5s' }}></div>
          <div className="absolute bottom-1/3 left-1/3 w-2 h-2 bg-orange-400 rounded-full animate-ping opacity-50" style={{ animationDelay: '2.5s' }}></div>
          {/* Futuristic Lines */}
          <div className="absolute top-0 left-1/2 w-px h-24 bg-gradient-to-b from-cyan-400 to-transparent animate-pulse" style={{ animationDelay: '0s' }}></div>
          <div className="absolute bottom-0 right-1/2 w-px h-24 bg-gradient-to-t from-pink-400 to-transparent animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute left-0 top-1/2 h-px w-24 bg-gradient-to-r from-purple-400 to-transparent animate-pulse" style={{ animationDelay: '0.5s' }}></div>
          <div className="absolute right-0 bottom-1/2 h-px w-24 bg-gradient-to-l from-cyan-400 to-transparent animate-pulse" style={{ animationDelay: '1.5s' }}></div>
          {/* Glowing Orbs */}
          <div className="absolute top-5 left-5 w-8 h-8 bg-cyan-500 rounded-full opacity-30 animate-ping shadow-lg" style={{ animationDelay: '0s', animationDuration: '2s' }}></div>
          <div className="absolute bottom-5 right-5 w-8 h-8 bg-pink-500 rounded-full opacity-30 animate-ping shadow-lg" style={{ animationDelay: '0.8s', animationDuration: '2.5s' }}></div>
        </div>
      </section>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full mx-4">
            <h2 className="text-2xl font-bold mb-4">Agendar Demonstração</h2>
            <form onSubmit={handleDemoSubmit} className="space-y-4">
              <input
                type="text"
                name="name"
                placeholder="Nome Completo"
                value={demoFormData.name}
                onChange={handleDemoChange}
                required
                className="w-full p-3 border rounded-lg focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
              <input
                type="email"
                name="email"
                placeholder="Email Profissional"
                value={demoFormData.email}
                onChange={handleDemoChange}
                required
                className="w-full p-3 border rounded-lg focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Telefone"
                value={demoFormData.phone}
                onChange={handleDemoChange}
                required
                className="w-full p-3 border rounded-lg focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
              <textarea
                name="message"
                placeholder="Mensagem ou necessidades específicas (opcional)"
                value={demoFormData.message}
                onChange={handleDemoChange}
                rows="3"
                className="w-full p-3 border rounded-lg focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              ></textarea>
              <div className="flex space-x-3">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 bg-gray-300 text-gray-800 py-2 rounded-lg hover:bg-gray-400 transition duration-300"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-300"
                >
                  Enviar Pedido
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;
